import React from "react";
import { useState, useEffect } from "react";
import { Autocomplete } from "@mui/material";
import { TextField } from '@mui/material';
import { useApi} from '/@/app/Api';
import { isObject } from "/@/app/utils";

import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';


export const ParameterAutocomplete = ({parameterChoice, setParameterChoice, disabled, sx}) => {
    const api=useApi();
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(parameterChoice);

    const fetchOptions = (query) => {
        // FIXME queue requests to keep order.
        query = encodeURIComponent(query);
        return api.request(
            `core/parameters/?limit=10&subpart=${query}`, {},
            {
                method: "GET",
            }
        ).then(data => {
            setOptions(data);
        }).catch(error => {
            setOptions([]);
        });
    };

    let timer;
    const handleInputChange = (event, value, reason) => {
        if (reason === 'input') {
            clearTimeout(timer);
            const _value = value.replace(/\s+/g, ' ').trim();
            if (_value.length < 3) {
                setLoading(false);
                setResult(null)
                return;
            }
            setLoading(true);
            timer = setTimeout(() => {
                fetchOptions(_value)
                    .finally(() => {
                        setLoading(false);
                        const found = findResult(_value);
                        if (found !== null) {
                            setResult({userDefined: false, value: found})
                        } else {
                            setResult({userDefined: true, value: _value})
                        }
                    });
            }, 500);
        }
    };

    const handleChange = (event, value) => {
        // actual selection
        setResult({
            'userDefined': false,
            'value': value,
        });
    }

    const findResult = (text) => {
        const textNormalized = text.replace(/\s+/g, ' ').trim().toLowerCase();
        for (let opt of options) {
            if (toLabel(opt).toLowerCase() === textNormalized) {
                return opt;
            }
        }
        return null
    }
    const toLabel = (option) => {
        if (isObject(option)) {
            return option.short_ru;
        }
        return option || "";  // string
    }

    useEffect(() => {
        if (!result?.value) {
            setParameterChoice({userDefined: true, value: null});
        } else {
            setParameterChoice(result);
        }
    }, [result])

    return (
        <>
            <Autocomplete
                freeSolo  // allows arbitrary values, but disables noOptionsText
                loading={loading}
                options={options}
                getOptionLabel={toLabel}
                defaultValue={() => toLabel(result.value)}
                onInputChange={handleInputChange}
                onChange={handleChange}
                disabled={disabled}
                noOptionsText="не найдено"
                loadingText="загружаем..."
                renderInput={
                    (params) =>
                        <TextField
                            {...params}
                            label="Название параметра"
                            variant="outlined"
                        />
                }
                sx={{...sx}}
                renderOption={(props, option, { inputValue }) => {
                    const { key, ...optionProps } = props;
                    const matches = match(toLabel(option), inputValue, { insideWords: true });
                    const parts = parse(toLabel(option), matches);

                    return (
                        <li key={key} {...optionProps}>
                            <div>
                                {parts.map((part, index) => (
                                    <span
                                        key={index}
                                        style={{
                                            fontWeight: part.highlight ? 700 : 400,
                                        }}
                                    >
                                        {part.text}
                                    </span>
                                ))}
                            </div>
                        </li>
                    );
                }}
            />
        </>
    );
}
